import { render, staticRenderFns } from "./CardCoupon.vue?vue&type=template&id=f2208ac2&scoped=true&"
import script from "./CardCoupon.vue?vue&type=script&lang=js&"
export * from "./CardCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CardCoupon.vue?vue&type=style&index=0&id=f2208ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2208ac2",
  null
  
)

export default component.exports